import React from "react";
import { WarningModalBox, WarningModalTitle } from "../../../styled/web-map/market-share/MarketShare.styled";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { IoClose } from "react-icons/io5";
import { LoadingButton } from "@mui/lab";
import styled from "styled-components";

const WarningModal = ({
  cancelAction,
  acceptAction,
  open,
}) => {
  const ButtonStyle = styled(LoadingButton)`
    border-radius: 10px;
    height: fit-content;
    width: fit-content;
    margin-left: 10px;
    margin-right: 10px;
  `;
  const ButtonText = styled.div`
    font: normal normal normal 10px/11px Open Sans;
    white-space: nowrap;
    margin-right: 10px;
    margin-left: 10px;
  `;
  return (
    <WarningModalBox open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <WarningModalTitle>Data Reset Warning</WarningModalTitle>
      <IconButton
        aria-label="close"
        onClick={() => {
          cancelAction();
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: -2,
          color: (theme) => theme.palette.grey[500],
          zIndex: 1000,
          fontSize: 18,
        }}
      >
        <IoClose />
      </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        By changing this filter all the selected data will be cleared and will navigate to the initial market share map. Do you wish to continue?
      </DialogContent>
      <DialogActions>
        <ButtonStyle
          variant={"outlined"}
          size={"small"}
          onClick={() => {
            cancelAction();
          }}
        >
          <ButtonText>Cancel</ButtonText>
        </ButtonStyle>
        <ButtonStyle
          variant={"contained"}
          size={"small"}
          onClick={acceptAction}
        >
          <ButtonText>Continue</ButtonText>
        </ButtonStyle>
      </DialogActions>
    </WarningModalBox>
  )
}

export default WarningModal
